import $ from 'jquery'

$(document).ready( initDemo )

function initDemo(){
    
  //request demo mobile replacement
  if (jQuery('#mktoForm_1383').length || jQuery('#mktoForm_1965').length ) {
    MktoForms2.whenReady(function (form) {
      jQuery('#Lbliaminterestedin').attr('data-title', 'Select option');
      jQuery('#Lbliaminterestedin').click(function () {
        jQuery(this).toggleClass('open');
        jQuery('.mktoLogicalField.mktoCheckboxList').toggleClass('open');
      });
      jQuery('#Lbliaminterestedin').click(function () {
        if (jQuery(this).hasClass('open')) {
          jQuery(this).attr('data-title', 'Select option');
        } else {
          var checkedBox = jQuery('input[name="iaminterestedin"]:checked');
          var length = checkedBox.length;
          var checkedBoxesValues = "";
          jQuery(checkedBox).each(function (index, element) {
            if (index === (length - 1)) {
              checkedBoxesValues += this.value.toString();
            } else {
              checkedBoxesValues += this.value.toString() + ', ';
            }
          });
          if (checkedBoxesValues == '') {
            checkedBoxesValues = 'Select option';
          }
          jQuery(this).attr('data-title', checkedBoxesValues);
          console.log(checkedBoxesValues);
        }
      });
      var invalidDomains = ["@gmail.", "@yahoo.", "@hotmail.", "@live.", "@aol.", "@outlook.", "@icloud.", "@company."];

      MktoForms2.whenReady(function (form) {
        form.onValidate(function () {
          var email = form.vals().Email.toLowerCase();
          if (email) {
            if (!isEmailGood(email)) {
              form.submitable(false);
              var emailElem = form.getFormElem().find("#Email");
              form.showErrorMessage("Must be Business email.", emailElem);
            } else {
              form.submitable(true);
            }
          }
        });
      });

      function isEmailGood(email) {
        for (var i = 0; i < invalidDomains.length; i++) {
          var domain = invalidDomains[i];
          if (email.indexOf(domain) != -1) {
            return false;
          }
        }
        return true;
      }
    });
  }

}
